module.exports = __webpack_public_path__ + "32b5f9598203b58447a7f11129cee262.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/DepositConfirmation/piggy-bank.svg
// module id = 2430
// module chunks = 0 1